import { useServerConfiguration } from '../../modules/core/configuration/components/ServerConfigurationProvider';
import { ServerProviderType } from '../types/common';

export const useProviderType = () => {
  const serverConfig = useServerConfiguration();

  const { providerType } = serverConfig.telephonyCapabilities;

  return {
    isMSTeams: providerType === ServerProviderType.MSTeams,
    isRingCentral: providerType === ServerProviderType.RingCentral,
    isPCA: providerType === ServerProviderType.PCA,
  };
};